import { render, staticRenderFns } from "./ten.vue?vue&type=template&id=40cfea88&scoped=true&"
import script from "./ten.vue?vue&type=script&lang=js&"
export * from "./ten.vue?vue&type=script&lang=js&"
import style0 from "./ten.vue?vue&type=style&index=0&id=40cfea88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cfea88",
  null
  
)

export default component.exports